<div class="relative w-full">
	<p
		class="truncate text-gray-700 pb-2"
		[ngClass]="getSizeClass_()"
		*ngIf="label()"
	>
		{{ label() }}
	</p>

	<!-- Default mode (single select) -->
	<button
		*ngIf="!isMultiMode_()"
		#triggerButton
		type="button"
		class="border border-gray-200"
		[attr.aria-label]="selectedSingle_()?.text || placeholder_()"
		[attr.aria-expanded]="isExpanded_()"
		[attr.aria-controls]="ariaControlsId"
		[attr.aria-disabled]="!hasOptions_()"
		aria-haspopup="listbox"
		[disabled]="disabled() || !hasOptions_()"
		(click)="onClick()"
		[ngClass]="buttonClasses_()"
	>
		<div>
			<ui-avatar
				*ngIf="
					size() !== 'sm' &&
					selectedSingle_() &&
					(selectedSingle_().avatarInitials || selectedSingle_().avatarSrc)
				"
				[src]="selectedSingle_().avatarSrc"
				[initials]="selectedSingle_().avatarInitials"
				[variant]="buttonTriggerVariant_()"
				[size]="avatarSize_()"
			/>
			<span>{{ selectedSingle_()?.text || placeholder_() }}</span>
		</div>

		<i-tabler
			class="flex duration-300"
			[class.rotate-180]="isExpanded_()"
			[attr.aria-label]="isExpanded_() ? 'chevron up' : 'chevron down'"
			[name]="'chevron-down'"
			role="img"
		/>
	</button>

	<!-- Multi-select mode -->
	<div
		*ngIf="isMultiMode_()"
		class="min-h-[40px] w-full border border-gray-200 rounded-md p-2 cursor-text flex flex-wrap gap-2 items-center"
		[class.bg-gray-50]="disabled()"
		[class.cursor-not-allowed]="disabled()"
		(click)="focusSearchInput()"
	>
		<!-- Selected pills -->
		@for (option of selectedArray_(); track option.id) {
			<div
				class="inline-flex items-center gap-1 pl-2 bg-tealGreen-100 text-tealGreen-700 rounded-md text-sm -my-0.5"
			>
				<span>{{ option.text }}</span>
				<button
					type="button"
					class="hover:bg-tealGreen-200 rounded-md w-4 h-4 flex items-center justify-center"
					(click)="removeSelected(option, $event)"
					[attr.aria-label]="'Remove ' + option.text"
				>
					<i-tabler name="x" class="w-3 h-3" />
				</button>
			</div>
		}

		<!-- Inline search input -->
		<input
			#searchInput
			*ngIf="searchable() || allowCustom()"
			type="text"
			[(ngModel)]="searchQuery_"
			(keydown)="onSearchKeyDown($event)"
			(focus)="onSearchFocus()"
			(blur)="onSearchBlur()"
			[disabled]="disabled()"
			class="flex-1 min-w-[120px] outline-none bg-transparent text-sm"
			[placeholder]="selectedArray_().length === 0 ? placeholder_() : ''"
		/>

		<!-- Placeholder when empty and not searchable -->
		<span
			*ngIf="!searchable() && !allowCustom() && selectedArray_().length === 0"
			class="text-gray-500 text-sm"
		>
			{{ placeholder_() }}
		</span>
	</div>

	<div
		*ngIf="isExpanded_()"
		[@dropdown]
		[id]="ariaControlsId"
		class="absolute h-fit z-10 mt-2 flex flex-col w-full max-h-64 rounded-md bg-white shadow-lg overflow-hidden"
		(focusout)="onListboxFocusOut($event)"
	>
		<!-- Options list - Single select mode -->
		<ul
			*ngIf="!isMultiMode_() && (hasOptions_() || allowCustom())"
			class="p-2 flex flex-col gap-2 overflow-y-auto"
			cdkListbox
			[cdkListboxValue]="selected_()"
			(cdkListboxValueChange)="onSelect($event.value)"
			[cdkListboxCompareWith]="compareOptions"
			(keydown)="onKeyDown($event)"
		>
			@for (option of filteredOptions_(); track option.id) {
				<button
					#optionBtn
					class="group hover:bg-gray-50 focus-visible:bg-gray-50 aria-selected:bg-gray-50"
					[attr.aria-label]="option.text"
					[ngClass]="buttonClasses_()"
					[cdkOption]="option"
				>
					<div>
						<ui-avatar
							*ngIf="
								size() !== 'sm' && (option.avatarInitials || option.avatarSrc)
							"
							[src]="option.avatarSrc"
							[initials]="option.avatarInitials"
							[variant]="variantOrderList[$index % variantOrderList.length]"
							[size]="avatarSize_()"
						/>
						<span>{{ option.text }}</span>
					</div>
					<i-tabler
						class="hidden group-aria-selected:flex"
						name="check"
						role="img"
					/>
				</button>
			}
		</ul>

		<!-- Options list - Multi select mode -->
		<div
			*ngIf="isMultiMode_() && (hasOptions_() || allowCustom())"
			class="p-2 flex flex-col gap-2 overflow-y-auto"
			(keydown)="onKeyDown($event)"
		>
			@for (option of filteredOptions_(); track option.id) {
				<button
					type="button"
					class="group hover:bg-gray-50 focus-visible:bg-gray-50"
					[class.bg-gray-50]="isOptionSelected(option)"
					[attr.aria-label]="option.text"
					[ngClass]="buttonClasses_()"
					(click)="onSelect([option])"
				>
					<div>
						<ui-avatar
							*ngIf="
								size() !== 'sm' && (option.avatarInitials || option.avatarSrc)
							"
							[src]="option.avatarSrc"
							[initials]="option.avatarInitials"
							[variant]="variantOrderList[$index % variantOrderList.length]"
							[size]="avatarSize_()"
						/>
						<span>{{ option.text }}</span>
					</div>
					<i-tabler
						[class.hidden]="!isOptionSelected(option)"
						name="check"
						role="img"
					/>
				</button>
			}

			<!-- Custom value hint -->
			<div
				*ngIf="
					allowCustom() && searchQuery_() && filteredOptions_().length === 0
				"
				class="px-3 py-2 text-sm text-gray-500 italic"
			>
				Press Enter to add "{{ searchQuery_() }}"
			</div>
		</div>
	</div>
</div>
